import styled from '@emotion/styled';

const OptionName = styled('h4')({
  marginRight: 'auto',
  fontWeight: 400,
});

export default OptionName;
